/** Lightweight startup / section-load timing markers for perf baselines. */

const PREFIX = 'mm-perf'
const marks = new Map<string, number>()
const measures: Array<{ name: string; ms: number; at: string }> = []

export function perfMark(name: string): void {
  const now = typeof performance !== 'undefined' ? performance.now() : Date.now()
  marks.set(name, now)
  if (typeof performance !== 'undefined' && typeof performance.mark === 'function') {
    try {
      performance.mark(`${PREFIX}:${name}`)
    } catch {
      /* ignore duplicate marks */
    }
  }
  if (import.meta.env.DEV) {
    console.debug(`[perf] mark ${name}`)
  }
}

export function perfMeasure(name: string, startMark: string, endMark?: string): number | null {
  const start = marks.get(startMark)
  const end = endMark ? marks.get(endMark) : (typeof performance !== 'undefined' ? performance.now() : Date.now())
  if (start == null || end == null) return null
  const ms = Math.round(end - start)
  const row = { name, ms, at: new Date().toISOString() }
  measures.push(row)
  try {
    sessionStorage.setItem('mastermind-perf-measures', JSON.stringify(measures.slice(-40)))
  } catch {
    /* ignore quota */
  }
  if (import.meta.env.DEV) {
    console.info(`[perf] ${name}: ${ms}ms`)
  }
  return ms
}

export function getPerfMeasures() {
  return [...measures]
}
